import * as types from '../../action-types';
import {getSingleConsumer as initialState } from "../../initialState";

const getSingleConsumer = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_CONSUMER_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_CONSUMER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_CONSUMER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_CONSUMER_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSingleConsumer;
